module.exports = __webpack_public_path__ + "img/sticker_8.eddfd094.svg";